// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import Client from '../Client';

export default class PurgeCacheEvents extends Client {
  constructor(options = {}) {
    super({
      serviceName: 'purge-cache',
      serviceVersion: 'v1',
      exchangePrefix: 'exchange/taskcluster-purge-cache/v1/',
      ...options,
    });
  }
  /* eslint-disable max-len */
  // When a cache purge is requested  a message will be posted on this
  // exchange with designated `provisionerId` and `workerType` in the
  // routing-key and the name of the `cacheFolder` as payload
  /* eslint-enable max-len */
  purgeCache(pattern) {
    const entry = {type:'topic-exchange',exchange:'purge-cache',name:'purgeCache',routingKey:[{name:'routingKeyKind',constant:'primary',multipleWords:false,required:true},{name:'provisionerId',multipleWords:false,required:true},{name:'workerType',multipleWords:false,required:true}],schema:'http://schemas.taskcluster.net/purge-cache/v1/purge-cache-message.json#'}; // eslint-disable-line

    return this.normalizePattern(entry, pattern);
  }
}



// WEBPACK FOOTER //
// ./src/clients/PurgeCacheEvents.js